import { useRef, useEffect } from "react";

export const useDidUpdateEffect = (callback: () => void, deps: any[]) => {
    const firstUpdate = useRef(false);

    useEffect(() => {
        if (firstUpdate.current) callback();
        else firstUpdate.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
